(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patas-slides"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pf-slides')) customElements.define('pf-slides',class extends HTMLElement{
connectedCallback(){this.index=0;this.paused=false;this.controller=new AbortController();this.slides=[...this.querySelectorAll('.pf-slide')];this.addEventListener('click',e=>{const dot=e.target.closest('[data-pf-slide]');if(dot){this.show(Number(dot.dataset.pfSlide));this.restart()}const pause=e.target.closest('.pf-pause');if(pause){this.paused=!this.paused;this.querySelectorAll('.pf-pause').forEach(b=>b.setAttribute('aria-pressed',String(this.paused)));this.restart()}},{signal:this.controller.signal});this.addEventListener('mouseenter',()=>clearInterval(this.timer),{signal:this.controller.signal});this.addEventListener('mouseleave',()=>this.restart(),{signal:this.controller.signal});this.addEventListener('focusin',()=>clearInterval(this.timer),{signal:this.controller.signal});this.addEventListener('focusout',()=>this.restart(),{signal:this.controller.signal});this.show(0);this.restart()}
show(i){this.index=i;this.slides.forEach((s,n)=>s.hidden=n!==i);this.querySelectorAll('[data-pf-slide]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.pfSlide)===i)))}
restart(){clearInterval(this.timer);if(!this.paused&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&this.slides.length>1)this.timer=setInterval(()=>{if(!document.hidden)this.show((this.index+1)%this.slides.length)},6500)}
disconnectedCallback(){clearInterval(this.timer);this.controller.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
